import { useMutation } from '@apollo/client';
import { Alert, Box, Button, TextField } from '@mui/material';
import { styled } from '@mui/system';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { CREATE_USER } from '~/shared/mutations';

const PageWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const FormWrapper = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 600,
  width: '100%',
  gap: theme.spacing(2),
}));

interface FormData {
  email: string;
  name: string;
}

const Home = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: '',
      name: '',
    },
  });

  const [createUser, { loading, error }] = useMutation(CREATE_USER);

  const onSubmit: SubmitHandler<FormData> = async (formData) => {
    if (loading) {
      return;
    }
    if (!formData.email) {
      return;
    }

    try {
      await createUser({
        variables: {
          input: {
            name: formData.name,
            email: formData.email,
          },
        },
      });
    } catch {
      // Error surfaced via mutation's error state
    }
  };

  return (
    <PageWrapper>
      <FormWrapper onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <TextField
              label="Name"
              aria-invalid={errors.name ? 'true' : 'false'}
              {...field}
            />
          )}
        />
        <Controller
          name="email"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              label="Email"
              aria-invalid={errors.email ? 'true' : 'false'}
              error={Boolean(errors.email)}
              required
              {...field}
            />
          )}
        />
        {error && <Alert severity="error">{error.message}</Alert>}
        <Button type="submit" variant="contained" disabled={loading}>
          {loading ? 'Submitting…' : 'Submit'}
        </Button>
      </FormWrapper>
      <Link to="/user/1">User 1</Link>
    </PageWrapper>
  );
};

export default Home;
